import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon, LogOutIcon } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
}
export function Sidebar({
  isOpen,
  onToggle
}: SidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const baseRoute = '/production';
  return <aside className={`fixed left-0 top-0 bottom-0 bg-white border-r border-gray-200 transition-all duration-300 z-10 hidden lg:flex lg:flex-col
        ${isOpen ? 'w-64' : 'w-16'}`} data-id="element-1141">
      <button onClick={onToggle} className="absolute -right-3 top-3 bg-white border border-gray-200 rounded-full p-1 hover:bg-gray-50 shadow-sm" data-id="element-1142">
        {isOpen ? <ChevronLeftIcon size={16} className="text-gray-600" data-id="element-1143" /> : <ChevronRightIcon size={16} className="text-gray-600" data-id="element-1144" />}
      </button>
      <div className="flex-none flex items-center justify-center p-6 border-b border-gray-200" data-id="element-1145">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cXpe6vYCRQbGddRXvPPX35/Bildschirmfoto_2025-04-22_um_15.15.25.png" alt="Cirkel Logo" className={`${isOpen ? 'w-36' : 'w-10'} transition-all duration-300`} data-id="element-1146" />
      </div>
      <nav className="flex-1 flex flex-col p-2" data-id="element-1147">
        <ul className="space-y-1" data-id="element-1148">
          <li data-id="element-1149">
            <Link to={`${baseRoute}/`} className={`flex items-center rounded-lg ${location.pathname === '/production' ? 'bg-[#3498dd] text-white' : 'text-gray-700 hover:bg-gray-100'} ${isOpen ? 'px-3 py-2' : 'p-2 justify-center'}`} data-id="element-1150">
              <HomeIcon size={20} data-id="element-1151" />
              {isOpen && <span className="ml-3" data-id="element-1152">Auftragsübersicht</span>}
            </Link>
          </li>
          <li data-id="element-1153">
            <Link to={`${baseRoute}/settings`} className={`flex items-center rounded-lg ${location.pathname === '/production/settings' ? 'bg-[#3498dd] text-white' : 'text-gray-700 hover:bg-gray-100'} ${isOpen ? 'px-3 py-2' : 'p-2 justify-center'}`} data-id="element-1154">
              <SettingsIcon size={20} data-id="element-1155" />
              {isOpen && <span className="ml-3" data-id="element-1156">Einstellungen</span>}
            </Link>
          </li>
        </ul>
      </nav>
      <div className="flex-none p-2 mt-auto border-t border-gray-200" data-id="element-1157">
        <button onClick={() => navigate('/')} className={`w-full flex items-center rounded-lg text-gray-700 hover:bg-gray-100 ${isOpen ? 'px-3 py-2' : 'p-2 justify-center'}`} data-id="element-1158">
          <LogOutIcon size={20} data-id="element-1159" />
          {isOpen && <span className="ml-3" data-id="element-1160">Zurück zur Modulübersicht</span>}
        </button>
      </div>
    </aside>;
}